import App from './App';
import Arr from './lib/Arr';
import axios from './lib/Axios';
import Errors from './mixins/Errors';
import EventBus from './mixins/EventBus';
import Events from './lib/Events';
import FooterMessages from './mixins/FooterMessages';
import Modal from './components/Global/Modal';
import Modals from './mixins/Modals';
import numFormat from 'vue-filter-number-format';
import router from './router';
import store from './store';
import Validation from './mixins/Validation';
import Vue from 'vue';
import VueGeolocation from 'vue-browser-geolocation';
import VueGtm from 'vue-gtm';
import VueScrollTo from 'vue-scrollto';

Vue.config.productionTip = false;

window._ = require('lodash');
window.axios = axios;
window.Arr = Arr;
window.Events = Events;
window.moment = require('moment');
window.queryString = require('query-string');

// Extensions.
Vue.use(VueGeolocation);
Vue.use(VueScrollTo);
Vue.use(VueGtm, {
  id: process.env.VUE_APP_GTM_KEY,
  enabled: true,
  debug: false
});

// Filters.
Vue.filter('numFormat', numFormat);

// Components.
Vue.component('modal', Modal);

// Mixins.
Vue.mixin(Errors);
Vue.mixin(EventBus);
Vue.mixin(FooterMessages);
Vue.mixin(Modals);
Vue.mixin(Validation);

// Dispatch an event through our own bus when Google libs are loaded.
window.googleLibsLoaded = () => window.Events.dispatch('google.load');

// Initialise the app.
new Vue({
  router,
  store,
  render: h => h(App),
  created() {
    this.$store.dispatch('rates/fetchPrices');
  },
}).$mount('#app');
